import React, {Component} from 'react';
import Breadcrumbs_Schema_org from "./Breadcrumbs_Schema_org";
import {Helmet} from "react-helmet";
import {Link} from "react-router";

class Breadcrumbs_component extends Component {
    
    constructor(props, context) {
        super(props, context);
        
        this.createListBreadcrumbs = this.createListBreadcrumbs.bind(this);
        
    }
    
    createListBreadcrumbs() {
        return this.props.listBreadcrumbs.map((breadcrumb, index, {length}) => {
            return (
                <span key={"breadcrumb-" + index}>
                    <Link to={breadcrumb.path}>{breadcrumb.title}</Link>{(length - 1 === index) ? "" : " » "}
                </span>
            )
        })
    }
    
    render() {
        return (
            <div>
                {this.props.showBreadcrumbs &&
                    <div id="breadcrumb" className="breadcrumbs">
                        <nav>
                            <span>
                                {this.createListBreadcrumbs()}
                                {!this.props.mobileMode && <span className="breadcrumb_last" aria-current="page">{" » "}<strong>{this.props.lastElement}</strong></span>}
                            </span>
                        </nav>
                    </div>
                }
                <Helmet>
                    <Breadcrumbs_Schema_org
                        listBreadcrumbs={this.props.listBreadcrumbs}
                        lastElement={this.props.lastElement}
                        HOST={this.props.HOST}
                        currentPath={this.props.currentPath}
                    />
                </Helmet>
            </div>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
        
    }
    
    componentDidUpdate() {
    
    }
    
    
}

export default Breadcrumbs_component
